export default "__VITE_ASSET__63608c05__"